import React from 'react'
import { KibButtonNew } from '@chewy/kib-controls-react'
import { KibTooltip, type KibTooltipProps } from '@chewy/kib-tooltip-react'
import classNames from 'classnames'

import type { PopperAction } from './ActionsPopper'

import '@chewy/kib-tooltip-styles/dist/kib-tooltip.css'
import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css'
import styles from './RhapActionsPopper.module.scss'

export interface RhapActionsPopperProps extends KibTooltipProps {
  actions?: PopperAction[]
}

const renderMenuItem = ({ id, label = '', onClick, redText }: PopperAction) => {
  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    if (onClick) onClick(event)
  }

  return (
    <KibButtonNew
      className={classNames(styles.menuButton, {
        [styles.redTextColor]: redText,
      })}
      emphasis="tertiary"
      theme="utility"
      onClick={handleClick}
    >
      {label}
    </KibButtonNew>
  )
}

const RhapActionsPopper = ({
  actions = [],
  ...rest
}: RhapActionsPopperProps) => (
  <KibTooltip className={styles.tooltip} {...rest}>
    <div className={styles.actionsContainer}>
      {actions.filter(Boolean).map((item: PopperAction) => (
        <div key={item.id}>{renderMenuItem(item)}</div>
      ))}
    </div>
  </KibTooltip>
)

export default RhapActionsPopper
